import React from 'react';
import { Countdown } from './Countdown';
export function Urgency() {
  return <section className="w-full bg-night-deep" data-id="element-381" data-mp="2bwe6imbbrd3g">
      <div className="mx-auto max-w-3xl px-5 py-12 text-center sm:py-16" data-id="element-382" data-mp="2bvcry7v3o8gz">
        <p className="eyebrow text-saffron" data-id="element-383" data-mp="1x06ljjs3e7n4">Limited-time offer</p>
        <h2 className="mt-3 font-display text-2xl text-sand sm:text-4xl" data-id="element-384" data-mp="21yhy429ruw91">
          The launch price ends in:
        </h2>
        <div className="mt-6" data-id="element-385" data-mp="1o6ju25ux3qjq">
          <Countdown tone="dark" data-id="element-386" data-mp="1o6bjwlq6izc8" />
        </div>
        <p className="mt-5 text-sm text-sand/75" data-id="element-387" data-mp="1sxtlnc0113y9">
          After that the price goes up by{' '}
          <span className="font-bold text-coral" data-id="element-388" data-mp="1e8xfxllg030t">$42</span> and stays there.
        </p>
      </div>
    </section>;
}